export default __webpack_public_path__ + "static/media/location_color.8387ee98.svg";